export default "__VITE_PUBLIC_ASSET__acf3962c__"